import React from 'react';
import { priceFormatter } from '@noths/polaris-client-utils';

import type { Product } from 'src/types/dontgiftguide';
import * as styles from './ProductLabel.styles';

interface ProductLabelProps {
  product?: Product;
}

export const ProductLabel = ({ product }: ProductLabelProps) => {
  if (!product || !product.price || !product.partner) {
    return null;
  }

  const preSalePrice = product.preSalePrice?.gbp;

  return (
    <span>
      {product.title} by {product.partner.name} /
      <span css={styles.priceLabel}>
        {preSalePrice && (
          <span css={styles.preSalePrice}> {priceFormatter('GBP', preSalePrice)}</span>
        )}
        <b css={styles.price}>{priceFormatter('GBP', product.price.gbp)} »</b>
      </span>
    </span>
  );
};
